/**
 * Retrieves the GraphQL token from the "com.max.apps.token" cookie.
 * This JavaScript cookie is used by mobile app embed pages (e.g.: /offer),
 * to bypass the authentication and authorization process via SSO/CAS ($auth).
 * @returns {string|null} The GraphQL token or null if not found.
 */
export function getMobileAuthToken () {
  const authCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('com.max.apps.token='))
  const graphQLToken = authCookie?.split('=')[1].trim()

  if (!graphQLToken) return null
  return graphQLToken
}
